import React from 'react';
import { HeaderGroup } from 'react-table';
import { IBalanceInstruction } from '../../../../../../sp-types/balanceFlowType';

interface TableFooterProps {
  footerGroups: HeaderGroup<IBalanceInstruction>[];
}
export const ExecutionTableFooter: React.FC<TableFooterProps> = ({ footerGroups }) => (
  <tfoot>
    {footerGroups.map((footerGroup, index) => (
      <tr {...footerGroup.getFooterGroupProps()} key={index}>
        {footerGroup.headers.map((column) => (
          <td
            {...column.getFooterProps()}
            className="font-semibold text-sm py-[0.5rem] ps-[1rem] border border-gray-200"
            key={column.id}
          >
            {column.render('Footer')}
          </td>
        ))}
      </tr>
    ))}
  </tfoot>
);
